import React from 'react';
// import Link from 'react-router-dom/Link';
import 'antd/dist/antd.css';
import { Timeline, Icon, Button } from 'antd';
// import logo from '../../images/logo.svg';
import Link from 'react-router-dom/Link';
import './WhatAreWeSection.css';

const WhatAreWeSection = (props) => {
   return (
     <div className="WhatWeAreSection--container">
       <div className="WhatWeAreSection--timeline-container">
        <Timeline className="WhatWeAreSection--timeline">
          <Timeline.Item>Remote Simulated Physical Interactions</Timeline.Item>
          <Timeline.Item>Key Patents & Intellectual Property</Timeline.Item>
          <Timeline.Item>A Telemedicine Market Worth Billions!</Timeline.Item>
          <Timeline.Item>"the Missing Link" in Telemedicine</Timeline.Item>
        </Timeline>
      </div>

      <h1 className="WhatWeAreSection--headline">
         Revolutionizing Telemedicine
      </h1>


   


      <h2 className="WhatWeAreSection--subheadline1">
        Real Time Touch Interactions 
      </h2>
      <h3 className="WhatWeAreSection--subheadline2">
        with Augmented Reality &amp; Remote Monitoring Applications
      </h3>
      <div className="WhatWeAreSection--body-text">
        <h3 className="WhatWeAreSection--highlight">
          "the Missing Link in Telemedicine"
        </h3>
        

        
        <Icon type="caret-down" className="WhatWeAreSection--caretdown-icon" style={{ color:"#CE001B"}} />

        <div style={{margin:20}}>
          <Link to="/remoterx/">
            <img alt="Rx Remote Dispenser" className="img-rounded img-responsive" style={{maxWidth:400, border: "10px solid white"}} src="https://www.realtimetouch.com/images/remoterx/dispenser-phone-400-2.jpg" />
          </Link>
        </div>
          
        <h4>
          <span className="WhatWeAreSection--highlight-large">We're in active development of the<br /> World's First Remote Caregiver-controlled Rx Home Dispenser
         </span>
        </h4>
          <div style={{marginTop:30, marginBottom:20}}>
            <Link to="/remoterx/">
              <Button size="large" type="primary">
                <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" style={{marginRight: 4}} alt="PDF" />Find out More <Icon type="caret-right" />
              </Button>
            </Link>
          </div>

        <Icon type="caret-down" className="WhatWeAreSection--caretdown-icon" style={{ color:"#CE001B"}} />

        <div style={{margin:20}}>
          <img alt="RTT-4" className="img-rounded img-responsive" style={{maxWidth:400}} src="https://www.realtimetouch.com/images/general/rtt-4-400.jpg" />
        </div>

        <h4>
          <span className="WhatWeAreSection--highlight-large">New technology enables remote video doctor-nurse-patient physical interaction at home, or on a mobile device, for medical consultation & procedures.</span>
        </h4>

        <Icon type="caret-down" className="WhatWeAreSection--caretdown-icon" style={{ color:"#e24456"}} />
       
        <h4 style={{color: "white"}}>
          This new always-on distributed health combination of technologies holds promise in reducing hospital, clinic & medicine costs, serving those in need while maintaining high quality care & provider-patient relationships.
        </h4>

        <div style={{margin:20}}>
          <img alt="RTT-2" className="img-rounded img-responsive" style={{maxWidth:400}} src="https://www.realtimetouch.com/images/general/rtt-2-400.jpg" />
        </div>

       
        <Icon type="caret-down" className="WhatWeAreSection--caretdown-icon" style={{ color:"#f46b7b"}} />
       
        <h4 style={{color:"white"}}>
          Real Time Touch has potential to radically transform the medical industry--
        </h4>
        
        {/* <Icon type="caret-down" className="WhatWeAreSection--caretdown-icon" style={{ color:"#00b727"}} /> */}
       
        <h3 style={{color:"white"}}>
         Making a BILLION DOLLAR savings impact & saving lives!
        </h3>

        <Icon type="caret-down" className="WhatWeAreSection--caretdown-icon" style={{ color:"#f46b7b"}} />

        <h4 style={{color:"white"}}>
          Read more about Real Time Touch's extensive intellectual property and inventions...
        </h4>

        <Icon type="caret-down" className="WhatWeAreSection--caretdown-icon" style={{ color:"#f46b7b"}} />


        

      </div>
     </div>
   )
 }

 export default WhatAreWeSection;
  


// WEBPACK FOOTER //
// ./src/containers/WhatAreWeSection/WhatAreWeSection.js